<fury-page-layout mode="card">
    <fury-page-layout-header>
        <div class="header_vew">
            <fury-breadcrumbs current="View Agreement"></fury-breadcrumbs>
            <div class="top_heading">
              
                <div class="btn_panel">
                    <button mat-raised-button class="deepred" (click)="openActionModal('updateWaitingPeriod')" *ngIf="!isDenied">
                        <span>
                            Waiting Period
                        </span>
                     </button>
                     <button mat-raised-button class="lightBlue" (click)="handleCheckout()" *ngIf="!isDenied">
                        <span>
                           Update Coverage
                        </span>
                     </button>

                     <button mat-raised-button class="kawaiiTeal" (click)="handleRenew()" *ngIf="!isDenied  && agreementDetails?.paymentType !== 'Monthly'">
                        <span>
                           Renew Agreement
                        </span>
                     </button>

                     <button mat-raised-button class="deepgreen" (click)="handleAddSpecialRequest()">
                        <span>
                            Add Special Request
                        </span>
                     </button>

                     <button mat-raised-button class="green" (click)="openActionModal('updateContactInfo')" *ngIf="!isDenied">
                        <span>
                            Update Contact Information
                        </span>
                     </button>

                      <button mat-raised-button class="baby_pink" (click)="openActionModal('updateFreeMonth')" *ngIf="!isDenied">
                        <span>
                            Update Free Month
                        </span>
                     </button>

                     <button mat-raised-button class="orenge" (click)="openActionModal('updateAgreementHolderDetail')" *ngIf="!isDenied">
                        <span>
                            Update Agreement Holder
                        </span>
                     </button>
                     <button mat-raised-button class="deepredviolet" (click)="handleAddNotes()">
                        <span>
                            Add Notes
                        </span>
                     </button>
                     <button mat-raised-button class="deepblue" (click)="handleAddFeedback()">
                        <span>
                            Request Feedback
                        </span>
                     </button>
                     <button mat-raised-button class="deepviolet" (click)="handleFileClaimWithAgreement()" *ngIf="!isDenied">
                        <span>
                            File A Claim
                        </span>
                     </button>
                     <button mat-raised-button class="sky" (click)="handleChargeManually()" *ngIf="!isDenied">
                        <span>
                            Charge Manually
                        </span>
                     </button>
                     <button mat-raised-button class="new_blue" (click)="handleOptionalItem()" *ngIf="!isDenied">
                        <span>
                            Manage Optional Items
                        </span>
                     </button>
                     <button mat-raised-button class="deepyellow" (click)="openActionModal('updateCustomerScore')" *ngIf="!isDenied">
                        <span>
                            Update Customer Score
                        </span>
                     </button>
                     <button mat-raised-button class="red" (click)="handleCancelAgreement()" *ngIf="!isDenied">
                        <span>
                            Cancel Agreement
                        </span>
                     </button>
                     <button mat-raised-button class="softgreen" (click)="handleUpgradeOrDowngradeAgreement('upgrade')" *ngIf="!isDenied">
                        <span>
                           Upgrade Agreement
                        </span>
                     </button>
                     <button mat-raised-button class="darkPink" (click)="handleUpgradeOrDowngradeAgreement('downgrade')" *ngIf="!isDenied">
                        <span>
                           Downgrade Agreement
                        </span>
                     </button>
                     <button mat-raised-button class="lightCoral" (click)="transferAgreement()" *ngIf="!isDenied">
                        <span>
                           Transfer Agreement
                        </span>
                     </button>
                     <button mat-raised-button class="lightBlue" (click)="handleRenewAgreement('upgrade')" *ngIf="!isDenied && commonService.renewPeriod(agreementDetails?.agreementExpireDate)">
                        <span>
                           Renew Agreement
                        </span>
                     </button>
                     <!-- <button mat-raised-button class="lightBlue" (click)="handleRenewAgreement('upgrade')" >
                        <span>
                           Renew Agreement
                        </span>
                     </button> -->

                     <button mat-raised-button class="darkGreen" (click)="sendOrderConfirmation()" *ngIf="!isDenied">
                        <span>
                            Send Order Confirmation
                        </span>
                     </button>

                     
                     <button mat-raised-button class="darkGrey" (click)="sendServiceAgreementMail()" *ngIf="!isDenied">
                        <span>
                            Email Service Agreement
                        </span>
                     </button>
                     <button mat-raised-button class="lightGreen" (click)="getServiceAgreementPdf()">
                        <span>
                           Download Agreement
                        </span>
                     </button>
                     <button mat-raised-button class="purple" (click)="changeAgreementStatus()" *ngIf="agreementDetails?.paymentMethod === 'escrow-invoice' && agreementDetails?.status === 'Pending Payment'">
                        <span>
                           Change Payment Status
                        </span>
                     </button>
                     <button mat-raised-button class="tealBlue" (click)="openActionModal('sendEscrowConfirmationMail')" *ngIf="!isDenied && agreementDetails?.paymentMethod === 'escrow-invoice'">
                        <span>
                            Send Escrow Confirmation Mail
                        </span>
                     </button>
                      <button mat-raised-button class="amber" (click)="getEscrowInvoice()" *ngIf="!isDenied && agreementDetails?.paymentMethod === 'escrow-invoice'">
                        <span>
                            Download Escrow Invoice
                        </span>
                     </button>
                </div>
    
                <div>
                    
                      <button mat-button class="can-button"
                    (click)="redirectToDashboard()"><mat-icon>keyboard_backspace</mat-icon> Back</button>
                </div>
                
            </div>
        </div>
        
    </fury-page-layout-header>

    <div class="lebel_section">
        <fury-common-label-section [mainPage]="'viewAgreements'"></fury-common-label-section>
    </div>

    <fury-page-layout-content [@fadeInUp]>
        <div class="two_section">
            <div class="customer_leftinfo">
                <fury-customer-side-menu [fetchUser]="fetchUser"></fury-customer-side-menu>
            </div>
            <div class="righpanel">

                <div class="block_area">
                    <fury-common-kpi-blocks [mainPage]="'viewAgreements'" [data]="kpiData"></fury-common-kpi-blocks>
                </div>
                <div class="view_panel">

                    <div class="panel_heading">
                        <h2>
                            Covered Address
                        </h2>

                    </div>

                    <div class="claim_showprt">
                        <div class="claim_inputprt">
                            <label>
                                Address
                            </label>
                            <p>
                                {{agreementDetails?.coveredAddress?.streetAddress?.split(',')[0]}}

                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Unit #
                            </label>
                            <p>
                                {{agreementDetails?.coveredAddress?.unitNumber}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                City
                            </label>
                            <p>
                                {{agreementDetails?.coveredAddress?.city}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                State
                            </label>
                            <p>
                                {{agreementDetails?.coveredAddress?.state}}
                            </p>
                        </div>

                        <div class="claim_inputprt">
                            <label>
                                Zip
                            </label>
                            <p>
                                {{agreementDetails?.coveredAddress?.zip}}
                            </p>
                        </div>

                    </div>

                    <div class="gap"></div>
                    <div class="panel_heading">
                        <h2>
                            Agreement Holder
                        </h2>
                        <div class="panel_editsection" *ngIf="!isDenied">
                            <mat-icon *ngIf="editingTab !== allSections.AgreementHolder" (click)="editSection(allSections.AgreementHolder)" class="edit_icon">edit</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.AgreementHolder" (click)="cancelSection()" class="cancel_icon">close</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.AgreementHolder" (click)="saveSection(allSections.AgreementHolder)" class="done_icon">done</mat-icon>
                        </div>
                    </div>
                
                    <div class="claim_showprt" *ngIf="editingTab !== allSections.AgreementHolder">
                        <div class="claim_inputprt">
                            <label>
                                First Name
                            </label>
                            <p>
                                {{agreementDetails?.firstName}}

                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Last Name
                            </label>
                            <p>
                                {{agreementDetails?.lastName}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Phone Number
                            </label>
                            <p>
                                {{agreementDetails?.phoneNumber | mask: '(000) 000-0000'}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Email Address
                            </label>
                            <p>
                                {{agreementDetails?.emailAddress}}
                            </p>
                        </div>


                    </div>

                    <ng-container *ngIf="editingTab === allSections.AgreementHolder" >
                        <form [formGroup]="agreementHolderForm">
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        First Name
                                    </label>
                                    <span>
                                        <input formControlName="firstName"/>
                                        <mat-error  *ngIf="agreementHolderForm.controls['firstName'].touched && agreementHolderForm.controls['firstName'].hasError('required')">
                                            This is required field.
                                        </mat-error>
                                    </span>
                                   
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Last Name
                                    </label>
                                    <span>
                                        <input formControlName="lastName"/>
                                        <mat-error  *ngIf="agreementHolderForm.controls['lastName'].touched && agreementHolderForm.controls['lastName'].hasError('required')">
                                            This is required field.
                                        </mat-error>
                                    </span>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                   Phone Number
                                    </label>
                                    <span>
                                        <input type="text" formControlName="phoneNumber" mask="(000) 000-0000" />
                                        <mat-error  *ngIf="agreementHolderForm.controls['phoneNumber'].touched && agreementHolderForm.controls['phoneNumber'].hasError('required')">
                                            This is required field.
                                        </mat-error>
                                        <mat-error  *ngIf="agreementHolderForm.controls['phoneNumber'].touched && agreementHolderForm.controls['phoneNumber'].hasError('mask')">
                                            Enter valid phone number.
                                        </mat-error>
                                    </span>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Email Address
                                    </label>
                                    <span>
                                        <input formControlName="emailAddress"/>
                                        <mat-error  *ngIf="agreementHolderForm.controls['emailAddress'].touched && agreementHolderForm.controls['emailAddress'].hasError('required')">
                                            This is required field.
                                        </mat-error>
                                        <mat-error *ngIf="agreementHolderForm.controls['emailAddress'].touched && agreementHolderForm.controls['emailAddress'].hasError('pattern')">
                                            Enter Valid email address.
                                        </mat-error>
                                    </span>
                                </div>

                            </div>
        
                         </form>
                    </ng-container> 
                    <div class="gap"></div>

                    <div class="panel_heading">
                        <h2>
                            Contact Information
                        </h2>
                        <div class="panel_editsection" *ngIf="!isDenied">
                            <mat-icon *ngIf="editingTab !== allSections.ContactInformation" (click)="editSection(allSections.ContactInformation)" class="edit_icon">edit</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.ContactInformation" (click)="cancelSection()" class="cancel_icon">close</mat-icon>
                            <mat-icon *ngIf="editingTab === allSections.ContactInformation" (click)="saveSection(allSections.ContactInformation)" class="done_icon">done</mat-icon>
                        </div>
                    </div>
                    <div class="claim_showprt" *ngIf="editingTab !== allSections.ContactInformation">
             
                        <div class="claim_inputprt">
                            <label>
                                First Name
                            </label>
                            <p>
                                {{agreementDetails?.contactInfo?.firstName}}

                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Last Name
                            </label>
                            <p>
                                {{agreementDetails?.contactInfo?.lastName}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Phone Number
                            </label>
                            <p>
                                {{agreementDetails?.contactInfo?.phoneNumber | mask: '(000) 000-0000'}}
                            </p>
                        </div>
                        <div class="claim_inputprt">
                            <label>
                                Email Address
                            </label>
                            <p>
                                {{agreementDetails?.contactInfo?.emailAddress}}
                            </p>
                        </div>


                    </div>

                     <ng-container *ngIf="editingTab === allSections.ContactInformation" >
                            <form [formGroup]="contactInfoForm">
                                <div class="claim_showprt">
                                    <div class="claim_inputprt">
                                        <label>
                                            First Name
                                        </label>
                                        <span>
                                            <input formControlName="firstName"/>
                                            <mat-error  *ngIf="contactInfoForm.controls['firstName'].touched && contactInfoForm.controls['firstName'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </span>
                                       
                                    </div>
                                    <div class="claim_inputprt">
                                        <label>
                                            Last Name
                                        </label>
                                        <span>
                                            <input formControlName="lastName"/>
                                            <mat-error  *ngIf="contactInfoForm.controls['lastName'].touched && contactInfoForm.controls['lastName'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                        </span>
                                    </div>
    
                                    <div class="claim_inputprt">
                                        <label>
                                       Phone Number
                                        </label>
                                        <span>
                                            <input type="text" formControlName="phoneNumber" mask="(000) 000-0000" />
                                            <mat-error  *ngIf="contactInfoForm.controls['phoneNumber'].touched && contactInfoForm.controls['phoneNumber'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                            <mat-error  *ngIf="contactInfoForm.controls['phoneNumber'].touched && contactInfoForm.controls['phoneNumber'].hasError('mask')">
                                                Enter valid phone number.
                                            </mat-error>
                                        </span>
                                    </div>

                                    <div class="claim_inputprt">
                                        <label>
                                            Email Address
                                        </label>
                                        <span>
                                            <input formControlName="emailAddress"/>
                                            <mat-error  *ngIf="contactInfoForm.controls['emailAddress'].touched && contactInfoForm.controls['emailAddress'].hasError('required')">
                                                This is required field.
                                            </mat-error>
                                            <mat-error *ngIf="contactInfoForm.controls['emailAddress'].touched && contactInfoForm.controls['emailAddress'].hasError('pattern')">
                                                Enter Valid email address.
                                            </mat-error>
                                        </span>
                                    </div>
    
                                </div>
            
                             </form>
                        </ng-container> 
                        <div class="gap"></div>
                        <div class="panel_heading">
                            <h2>
                                Coverage Information
                            </h2>
                            <div class="panel_editsection"  *ngIf="!isDenied">
                                <mat-icon (click)="handleCheckout()" class="edit_icon">edit</mat-icon>
                                <!-- <mat-icon *ngIf="editingTab === allSections.ClaimInfo" (click)="cancelSection(allSections.ClaimInfo)" class="cancel_icon">close</mat-icon>
                                <mat-icon *ngIf="editingTab === allSections.ClaimInfo" (click)="saveSection(allSections.ClaimInfo)" class="done_icon">done</mat-icon> -->
                            </div>
                        </div>
                        <!-- <div class="claim_showprt" *ngIf="editingTab !== allSections.ClaimInfo"> -->
                        <div class="claim_showprt">
                            <div class="claim_inputprt">
                                <label>
                                    Status
                                </label>
                                <p>
                                    {{agreementDetails?.status}}
    
                                </p>
                            </div>
                            <div class="claim_inputprt">
                                <label>
                                    Plan Type Name
                                </label>
                                <p>
                                    {{agreementDetails?.planTypeName}}
                                </p>
                            </div>
                            <div class="claim_inputprt">
                                <label>
                                    Payment Term
                                </label>
                                <p>
                                    {{agreementDetails?.pricingOption}}
                                </p>
                            </div>
    
                            <div class="claim_inputprt">
                                <label>
                                    Copayment Fee
                                </label>
                                <p>
                                    {{agreementDetails?.copayFee | currency}}
                                </p>
                            </div>

                            <!-- <div class="claim_inputprt">
                                <label>
                                    Special Copayment Fee
                                </label>
                                <p>
                                  
                                </p>
                            </div> -->

                            <div class="claim_inputprt">
                                <label>
                                    Property Type
                                </label>
                                <p>
                                    {{agreementDetails?.orderPlanDetail?.orderPropertyTypeName}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Property Size
                                </label>
                                <p>
                                    {{agreementDetails?.orderPlanDetail?.orderPropertySizeName}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Waiting Period
                                </label>
                                <p>
                                    {{agreementDetails?.waitingPeriod}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Effective Term
                                </label>
                                <p>
                                    {{agreementDetails?.agreementEffectiveDate}} - {{agreementDetails?.agreementExpireDate || 'On-Going'}}
                                </p>
                            </div>

                            <div class="claim_inputprt">
                                <label>
                                    Days Active
                                </label>
                                <p>
                                {{commonService.daysActive(agreementDetails?.agreementEffectiveDate)}}
                               
                                </p>
                            </div>
    
                            
                            <div class="claim_inputprt">
                                <label>
                                    Premium Paid
                                </label>
                                <p>
                                    {{agreementDetails?.premiumPaid | currency}}
                                </p>
                            </div>

                                
                            
                            <div class="claim_inputprt">
                                <label>
                                    Premium Balance
                                </label>
                                <p>
                                    {{agreementDetails?.premiumBalance | currency}}
                                </p>
                            </div>

                                                        
                            <div class="claim_inputprt">
                                <label>
                                    Past Due
                                </label>
                                <p>
                                    {{agreementDetails?.pastDue | currency}}
                                </p>
                            </div>
                            
                            <div class="claim_inputprt">
                                <label>
                                    Payment Information
                                </label>
                                <p>
                                    {{agreementDetails?.paymentInfo}}
                                </p>
                            </div>
                        </div>
                        <div class="gap"></div>
                        <div class="panel_heading">
                            <h2>
                                Covered Items
                            </h2>
                        
                        </div>
                        <div class="claim_showprt">
                            <div class="claim_inputprt full-width">
                                <ul class="list_item">
                                    <li *ngFor="let item of agreementDetails?.orderPlanDetail?.orderMainPlanDetails?.coveredItems">
                                      
                                      <label>{{ item?.coveredItems?.title }} - <span> &nbsp;[{{item?.quantity || 0}}]</span></label>
                                      <span (click)="openCoveredItemDetailsModal(item?.coveredItems)" class="info"><mat-icon>info</mat-icon></span>
                                    </li>
                                  </ul>
                            </div>
                        </div>
                        <div class="gap"></div>

                        <div class="panel_heading">
                            <h2>
                                Optional Items
                            </h2>
                        
                        </div>
                        <div class="claim_showprt">
                            <div class="claim_inputprt full-width">
                                <ul class="list_item">
                                    <li *ngFor="let item of agreementDetails?.orderAdditionalItems">
                                      <label>{{ item?.orderCoveredItemDetail?.title }}</label>
                                      <span (click)="openCoveredItemDetailsModal(item?.orderCoveredItemDetail)" class="info"><mat-icon>info</mat-icon></span>
                                    </li>
                                  </ul>
                            </div>
                        </div>
                        <div class="gap"></div>
                        <fury-claim-tab [userId]="userId" [editorAccess]="editorAccess" [agreementId]="agreementId"></fury-claim-tab>
                        <div class="gap"></div>

                        <fury-billing-tabs [userId]="userId" [agreementId]="agreementId"></fury-billing-tabs>

                         <div class="gap"></div>
                            <div class="panel_heading">
                                <h2>
                                    Financial Stats
                                </h2>
        
                            </div>
        
                            <div class="claim_showprt">
                                <div class="claim_inputprt">
                                    <label>
                                        Agreement Premium
                                    </label>
                                    <p>
                                        {{financialStats?.agreementPremium | currency}}
        
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Agreement Balance
                                    </label>
                                    <p>
                                        {{financialStats?.agreementBalance | currency}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Monthly Premium
                                    </label>
                                    <p>
                                        {{financialStats?.monthlyPremium | currency}}
        
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Months used
                                    </label>
                                    <p>
                                        {{financialStats?.monthsUsed }}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Paid Premium
                                    </label>
                                    <p>
                                        {{financialStats?.paidPremium | currency}}
                                    </p>
                                </div>
                                
                                <div class="claim_inputprt">
                                    <label>
                                        Earned Premium
                                    </label>
                                    <p>
                                        {{financialStats?.earnedPremium | currency}}
                                    </p>
                                </div>
                                <div class="claim_inputprt">
                                    <label>
                                        Unearned Premium
                                    </label>
                                    <p>
                                        {{financialStats?.unearnedPremium | currency}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                       Net Unearned Premium
                                    </label>
                                    <p>
                                        {{financialStats?.netUnearnedPremium | currency}}
                                    </p>
                                </div>

           

                                <div class="claim_inputprt">
                                    <label>
                                        Net Refund
                                    </label>
                                    <p>
                                        {{financialStats?.netRefund | currency}}
                                    </p>
                                </div>
        

                                <div class="claim_inputprt">
                                    <label>
                                        Reserve
                                    </label>
                                    <p>
                                        {{financialStats?.reserve | currency}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Refund Amount
                                    </label>
                                    <p>
                                        {{financialStats?.refundAmount | currency}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Total Claims Paid
                                    </label>
                                    <p>
                                        {{financialStats?.totalClaimsPaid | currency}}
                                    </p>
                                </div>

                                <div class="claim_inputprt">
                                    <label>
                                        Gain/Loss
                                    </label>
                                    <p>
                                        {{financialStats?.gainOrLoss | currency}}
                                    </p>
                                </div>
        
                            </div>

                </div>
            </div>
        </div>
    </fury-page-layout-content>
</fury-page-layout>